import template from './partnersList.template.html';
import templateAttributesEdit from './partnerAttributesEdit.template.html';

export default {
  template,
  bindings: {
    partners: '=',
    accounts: '=',
    onChangePartnersAttributes: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $filter,
      $timeout,
      $mdMedia,
      $mdDialog,
      eventService,
      listService,
      authenticationService,
      PartnerAttributes,
      GOOGLEMAPS,
      PARTNER,
      INSTANCE
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.partners, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      this.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };
      this.getPartnerOwners = (partner) => {
        const idOwners =
          $rootScope.CurrentOrganization.partnersAttributes &&
          $rootScope.CurrentOrganization.partnersAttributes[partner.id] &&
          $rootScope.CurrentOrganization.partnersAttributes[partner.id].idOwners
            ? $rootScope.CurrentOrganization.partnersAttributes[partner.id].idOwners
            : [];
        return _.filter(this.accounts, (a) => idOwners.indexOf(a.id) > -1);
      };
      this.assignPartnerOwners = ($event, partner) => {
        eventService.partnerAssign({
          event: $event,
          currentPartner: partner,
          accounts: ctrl.accounts
        });
      };
      this.changePartnersAttributes = () => {
        ctrl.onChangePartnersAttributes({
          partnersAttributes: ctrl.CurrentOrganization.partnersAttributes
        });
      };
      this.editPartnerAttributes = ($event, partner, partnersAttributes) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {},
            template: templateAttributesEdit,
            controllerAs: '$ctrl',
            controller() {
              const self = this;
              self.currency = $rootScope.CurrentCurrency;
              self.partnerTypes = PARTNER.TYPES;
              self.isUser = false;
              self.partner = partner;
              self.isGemNzInstance = INSTANCE.identification === 'GNZ';
              self.partnerAttributes = partnersAttributes
                ? PartnerAttributes.build(partnersAttributes)
                : PartnerAttributes.blank();

              self.googleAutocompleteOptions = {
                componentRestrictions: GOOGLEMAPS.restrictToCountries
              };
              this.confirm = () => {
                $mdDialog.hide(self.partnerAttributes);
              };

              this.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((partnerAttributes) => {
            /* eslint-disable no-param-reassign */
            $rootScope.CurrentOrganization.partnersAttributes[partner.id] = partnerAttributes;
            /* eslint-enable no-param-reassign */
            ctrl.list.clear();
            ctrl.initialize();
            ctrl.changePartnersAttributes();
          });
      };

      /*
       * Helper Methods
       * --------------------------------------------------------------------------------
       */
      this.isOwner = () => authenticationService.isOwner();

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = (changes) => {
        if (changes.partners && changes.partners.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
